import { screenLock, screenUnlock } from "@/src/front/common";

$(function () {
  let windowWidth = window.innerWidth;
  gameSound();
  sideNav();
  checkCursor();

  const $canvas = $("#canvas");
  if ($canvas.length > 0) {
    $(document).on("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        $canvas.show();
      } else {
        $canvas.hide();
      }
    });
  }

  $(window).on("resize", function () {
    // load時のwindow幅が変更された時
    if (windowWidth != window.innerWidth) {
      if ($(".js-side-nav-content").hasClass("is-open")) {
        sideNavClose();
      }
      setTimeout(function () {
        windowWidth = window.innerWidth;
      }, 100);
    }
    checkInnerWidth(); // リサイズ時にもチェック
  });
  checkInnerWidth(); // 初期ロード時にもチェック
});

//==========
// ゲームプレイ画面のサウンドボタン
//==========
function gameSound() {
  var sound = $(".js-sound");
  const soundButton = sound.find(".js-sound-button");
  const soundRange = sound.find(".js-sound-range");

  //音量バーの挙動によって音声ON/OFF自動切り替え
  soundRange.on("change", function () {
    if ($(this).val() == "0") {
      soundButton.prop("checked", true);
    } else {
      soundButton.prop("checked", false);
    }
  });
}

//==========
// ゲームプレイ画面のサイドナビ
//==========
function sideNav() {
  $(".js-side-nav-tab").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("is-current")) {
      sideNavClose();
    } else {
      const target = $(this).attr("href"); //サイドナビ中身

      //タブのクラスつけ外し
      $(".js-side-nav-tab").removeClass("is-current");
      $(this).addClass("is-current");

      //サイドナビ外枠表示
      $(".js-side-nav-content").addClass("is-open");

      //サイドナビ中身表示
      $(".js-side-nav-panel").hide();
      $(target).show();

      //閉じるボタン表示
      $(".js-side-nav-close").addClass("is-show");

      updateGameDetail(true);
      updateScreenLock(true);
      checkInnerWidth();
    }
  });

  //閉じるボタンクリック時
  $(".js-side-nav-close").on("click", function () {
    sideNavClose();
  });
}

//サイドナビ閉じる挙動
function sideNavClose() {
  $(".js-side-nav-tab").removeClass("is-current");  //タブのカレントクラス外す
  $(".js-side-nav-content").removeClass("is-open"); //サイドナビ非表示
  $(".js-side-nav-close").removeClass("is-show");   //閉じるボタン非表示

  updateGameDetail(false);
  updateScreenLock(false);
  checkInnerWidth(); // サイドナビ開閉時にもチェック
}

// innerの幅を監視してクラスを付与する関数
function checkInnerWidth() {  
  const inner = document.querySelector(".game-detail-overview__inner");
  if (inner) {
    if (inner.offsetWidth <= 700) {
      inner.classList.add("is-wrapped");
    } else {
      inner.classList.remove("is-wrapped");
    }
  }
}

// サイドナビの状態に応じてゲーム画面を調節する関数
function updateGameDetail(navOpend) {
  const gameDetailMain = $(".js-game-detail-main");

  if (navOpend) {
    const windowWidth = window.innerWidth;
    const isPCWidth   = windowWidth >= 768;

    if (isPCWidth) {
      const detailWidth = gameDetailMain.width();
      const canvasWidth = $("#canvas").width();
      const navWidth    = $(".js-side-nav-content").width();
      const hasNoSpace  = (detailWidth - canvasWidth) / 2 < navWidth;

      if (hasNoSpace) {
        gameDetailMain.css("padding-right", navWidth);
      }
    }
  } else {
    gameDetailMain.css("padding-right", "0");
  }

  window.dispatchEvent(new Event("resize")); // resizeを発火して、Ggame.jsにcanvasサイズ更新を促す
}

// サイドナビの状態に応じて画面スクロールロックを更新する関数
function updateScreenLock(navOpend) {
  if (navOpend) {
    const windowWidth = window.innerWidth;
    const isSPWidth   = windowWidth < 768;

    if (isSPWidth) {
      screenLock();
    }
  } else {
    if ($("html").hasClass("is-locked")) {
      screenUnlock();
    }
  }
}

//==========
// ゲームプレイ画面のマウスカーソル表示
//==========
function checkCursor() {
  const $target = $(".js-cursor");
  let timerId = null;

  if ($target.length === 0) {
    return;
  }

  // タイマーをクリアして class も削除
  function clearTimer() {
    if (timerId !== null) {
      clearTimeout(timerId);
      timerId = null;
    }
    $target.removeClass("is-cursor-off");
    $("canvas").css("cursor", "default");
  }

  // タイマーを（再）スタート
  function startTimer() {
    clearTimer();
    timerId = setTimeout(() => {
      $target.addClass("is-cursor-off");
      $("canvas").css("cursor", "none");
    }, 5000);
  }

  // マウスが要素内に入った／動いたらタイマーリセット
  // マウスが出たらタイマークリア＆クラス削除
  $target.on({
    mouseenter: startTimer,
    mousemove: startTimer,
    mouseleave: clearTimer,
  });
}
